import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  StyleSheet,
  Text,
  View,
  Animated,
  TouchableNativeFeedback,
  TouchableWithoutFeedback,
  Dimensions,
  TouchableOpacity,
  Platform,
} from "react-native";

import {
  shadowStyle,
  alignItemsMap,
  isAndroid,
  touchableBackground,
  DEFAULT_ACTIVE_OPACITY,
} from "./utils";

const { width: WIDTH } = Dimensions.get("window");
const TEXT_HEIGHT = 22;

import appStyles from "../../../appStyles";
import { isWeb } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";

const TextTouchable = isAndroid
  ? TouchableNativeFeedback
  : TouchableWithoutFeedback;

export default class ActionButtonItem extends Component {
  static get defaultProps() {
    return {
      active: true,
      spaceBetween: 0,
      useNativeFeedback: true,
      activeOpacity: 1,
      fixNativeFeedbackRadius: false,
      nativeFeedbackRippleColor: "rgba(255,255,255,0.75)",
    };
  }

  static get propTypes() {
    return {
      active: PropTypes.bool,
      useNativeFeedback: PropTypes.bool,
      fixNativeFeedbackRadius: PropTypes.bool,
      nativeFeedbackRippleColor: PropTypes.string,
      activeOpacity: PropTypes.number,
    };
  }

  render() {
    const {
      size,
      position,
      verticalOrientation,
      hideShadow = true,
      spacing,
      noBorder = false,
    } = this.props;

    if (!this.props.active) return null;

    const animatedViewStyle = {
      marginBottom: 5,
      paddingBottom: 5,
      alignItems: alignItemsMap[position],
      marginRight: 5,
      opacity: this.props.anim,
      transform: [
        {
          translateY: this.props.anim.interpolate({
            inputRange: [0, 1],
            outputRange: [verticalOrientation === "down" ? -40 : 40, 0],
          }),
        },
      ],
    };

    const buttonStyle = {
      justifyContent: "center",
      alignItems: "center",
      width: size,
      height: size,
      borderColor: AppTheme.DEFAULT_COLOR,
      borderWidth: noBorder ? 0 : 2,
      borderRadius: size / 2,
      backgroundColor: "transparent" || this.props.btnColor,
    };

    if (position !== "center") {
      buttonStyle[position] = (this.props.parentSize - size) / 2;
    }

    const parentStyle =
      isAndroid && this.props.fixNativeFeedbackRadius
        ? {
            height: size,
            marginBottom: spacing,
            right: this.props.offsetX,
            borderRadius: this.props.size / 2,
          }
        : {
            paddingHorizontal: 10,
          };

    return (
      <Animated.View style={[animatedViewStyle, parentStyle]}>
        <TouchableOpacity
          style={[
            {
              display: "flex",
              alignItems: "center",
              flexDirection: "row-reverse",
              justifyContent: "center",
            },
            this.props.isSelected ? appStyles.highlight : {},
          ]}
        >
          <TouchableOpacity
            testID={this.props.testID}
            onPress={this.props.onPress}
          >
            <View
              style={[
                buttonStyle,
                !hideShadow
                  ? { ...shadowStyle, ...this.props.shadowStyle }
                  : null,
              ]}
            >
              {this.props.children}
            </View>
          </TouchableOpacity>

          {this._renderTitle()}
        </TouchableOpacity>

        {this.props.underline ? <View style={styles.underline} /> : null}
      </Animated.View>
    );
  }

  _renderTitle() {
    if (!this.props.title) return null;

    const { offsetX, parentSize, size, position, spaceBetween } = this.props;
    const offsetTop = Math.max(size / 2 - TEXT_HEIGHT / 2, 0);
    const positionStyles = { top: offsetTop };

    if (position !== "center") {
      positionStyles[position] =
        offsetX + (parentSize - size) / 2 + size + spaceBetween;
    } else {
      positionStyles.right = WIDTH / 2 + size / 2 + spaceBetween;
    }

    const title = React.isValidElement(this.props.title) ? (
      this.props.title
    ) : (
      <Text
        allowFontScaling={false}
        style={[styles.text, this.props.textStyle]}
      >
        {this.props.title}
      </Text>
    );

    return (
      <TextTouchable
        background={touchableBackground(
          this.props.nativeFeedbackRippleColor,
          this.props.fixNativeFeedbackRadius,
        )}
        activeOpacity={this.props.activeOpacity || DEFAULT_ACTIVE_OPACITY}
        onPress={this.props.onPress}
      >
        <View style={styles.textContainer}>{title}</View>
      </TextTouchable>
    );
  }
}

const styles = StyleSheet.create({
  textContainer: {
    paddingHorizontal: 8,
    backgroundColor: "transparent",
    height: TEXT_HEIGHT,
    marginRight: 10,
  },
  text: {
    flex: 1,
    fontSize: 13,
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "500",
    letterSpacing: -0.2,
    color: "#2D3142",
  },
  underline: {
    width: 300,
    borderBottomWidth: 1,
    borderColor: "#2D3142",
    marginTop: 10,
    marginRight: 9,
  },
});
